<template>
    <div v-if="infoData" :style="infoData.layout">

        <div :style="infoData.cont.imglayout">
            <img :src="infoData.cont.imgurl" width="100%"/>
        </div>

        <div style="width: 100%;margin: 0 auto;">
            <div :style="infoData.cont.titnamelayout">
                {{infoData.cont.titname}}
            </div>
            <div :style="infoData.cont.titsmlayout" v-html="infoData.cont.titsm"></div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "infoboxL",
        props:{
            infoData:{},
        },
        methods:{
            goto(it){
                console.log(it);
                if(it.type==undefined){return false}

                if(it.type=='link'){
                    window.open(it.url, it.target);
                }
                if(it.type=='rout'){
                    //this.$router.push({'path': it.url, query: {'id': it.valval}});
                    var url='';
                    if(it.valval!='') {
                        url = this.$router.resolve({path: it.url, query: {'id': it.valval}}).href;
                    }
                    if(it.valval==''){
                        url = this.$router.resolve({path: it.url}).href;
                    }
                    if(url!='') {
                        window.open(url, it.target);
                    }

                }


            },
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/comp/infoboxR.vue